<template>
  <div class="edit-video-box">
    <el-dialog
      :title="'批量转移子模块'"
      :visible.sync="dialogVisible"
      width="700px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="editParam"
        :rules="rules"
        label-position="left"
        label-width="110px"
      >
        <div class="form-flex-box">
          <el-form-item label="主题模块:" prop="subModuleID">
            <div style=" display: flex; ">
              <div style="height: 32px; width: 320px;">
                <el-cascader
                  :options="secondModuleList"
                  style="width:320px;"
                  v-model="editParam.subModuleID"
                  :props="{ emitPath: false, expandTrigger: 'hover' }"
                  @change="handleChangeModule"
                  clearable
                ></el-cascader>
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="form-flex-box">

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="submitDate()"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";

export default {
  data() {
    return {
      dialogVisible: false,
      isEdit: true,
      secondModuleList: [], // 二级模块列表
      editParam: {
        ids: "",
        subModuleID: "",
      },
      // 表单验证规则
      rules: {

      },
    };
  },
  methods: {

    // 提交验证
    submitDate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          API.subBatchModuleList(this.editParam).then((res)=>{
            if (res.code === 200) {
              this.$message({
                message: "批量转移成功",
                type: "success",
              });
              this.$emit("refresh");
              this.handleClose();
            } else {
              this.$message.error(res.msg);
            }
          })
          return;
        } else {
          return false;
        }
      });
    },

    getHotModule() {
      const params = {
        pageSize: 20,
        pageNumber: 1,
      };
      API.getModuleList(params).then((res) => {
        this.secondModuleList = this.transformData(res.data);
      });
    },
    transformData(originalData) {
      return originalData.map((module) => {
        return {
          value: module.moduleID,
          label: module.moduleName,
          children: module.list
            ? module.list.map((subModule) => {
                return {
                  value: subModule.moduleID,
                  label: subModule.moduleName,
                  children: subModule.subModules
                    ? subModule.subModules.map((item) => {
                        return {
                          value: item.id,
                          label: item.moduleName,
                        };
                      })
                    : null,
                };
              })
            : null,
        };
      });
    },
    handleChangeModule(val) {
      this.editParam.subModuleID = val
    },
    // 标签封面上传成功回掉
    successCallback(res) {
      this.editParam.cover = res.data.coverImg;
      this.editParam.coverThumb = res.data.coverImg;
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.getHotModule();
      this.dialogVisible = true;
      this.editParam.ids = data.ids

    },
    // 关闭回掉
    handleClose() {
      this.dialogVisible = false;
      this.isEdit = true;
      this.editTitle = true;
      this.$refs.form.resetFields();
    },


  },
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .el-select,
  .el-textarea,
  .el-select > .el-input,
  .el-input {
    width: 100% !important;
  }
  .form-flex-box {
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
}

/deep/ .el-cascader .el-input {
  width: 220px;
}

</style>
